export default __webpack_public_path__ + "static/media/ArtEmoji.65d0dd10.webp";